import { render } from "./ChurchPin.vue?vue&type=template&id=0e4f4fd7"
import script from "./ChurchPin.vue?vue&type=script&lang=js"
export * from "./ChurchPin.vue?vue&type=script&lang=js"

import "./ChurchPin.vue?vue&type=style&index=0&id=0e4f4fd7&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__